import React, { useEffect, useState } from 'react';
import { firebaseApp, auth } from '../../services/firebase'
import { signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import Styles from './styles/UserLogin.module.scss'
import CustomTextField from '../../components/general/CustomTextField'
import CustomButtonContained from '../../components/general/CustomButtonContained'
import Helpers from '../../utils/helpers'
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom'
import Colors from '../../config/colors'
import PositionedSnackbar from "../../components/general/PositionedSnackbar";
import { addUser } from '../../redux/slices/userSlice'
import { useDispatch } from 'react-redux'
import Config from '../../config'
import DDELogo from '../../assets/images/new_logo.png'
import CustomLoaderSpinner from "../../components/general/CustomLoaderSpinner";
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';


export default function ForgotPassword() {
	let dispatch = useDispatch()
	let navigate = useNavigate()

	const [loading, setLoading] = useState(false)
	const [email, setEmail] = useState('')
	const [password, setPassword] = useState('')
	const [showError, setShowError] = useState(false)
	const [errorMessage, setErrorMessage] = useState('')
	const [showPassword, setShowPassword] = useState(false)
	const [showSuccess, setShowSuccess] = useState(false)
	const [successMessage, setSuccessMessage] = useState('')


	const user = useSelector(state => {
		// console.log('inside home selector', state.user)
		return state.user
	})

	useEffect(() => {
		if (user.user)
			navigate('/home/work-orders')
	}, [user])

	const onSubmitClicked = async() => {
		if (!Helpers.validateEmail(email)) {
			setShowError(true)
			setErrorMessage('Please enter a valid email')
			return
		}

		setLoading(true)
		try {
			await sendPasswordResetEmail(auth, email);
			setLoading(false)
			setEmail('')
			setSuccessMessage('Password reset email sent! Check your inbox.')
			setShowSuccess(true)
		}catch (e) {
			console.error('Error when sending password reset email', e)
			setErrorMessage('Something went wrong. Please try again later.')
			setShowError(true)
		}
	}

	if(loading) {
		return (
			<div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
				<CustomLoaderSpinner />
			</div>
		)
	}

	return (
		<main>
			<div className={Styles.container} style={{ backgroundColor: Colors.backgroundColor }}>
				<PositionedSnackbar
					onClose={() => {
						setShowError(false)
						setShowSuccess(false)
						setErrorMessage('')
						setSuccessMessage('')
					}}
					severity={showError ? 'error' : 'success'}
					openFlag={showError || showSuccess}
					message={showError ? errorMessage : successMessage}
				/>

				<p style={{ fontWeight: 'bold', fontSize: 50, marginTop: 80 }}>LendCo</p>
				{/*<img*/}
				{/*	style={{marginTop: 50}}*/}
				{/*	className={Styles.logo}*/}
				{/*	src={DDELogo} height={200} width={300} />*/}

				<div className={Styles.formContainer}>
					<p style={{color: Colors.primaryTextColor, fontSize: 16}}>Enter the email to receive "reset password" link</p>
					<CustomTextField
						value={email}
						onChange={(text) => setEmail(text)}
						label={'Email'} />

					<CustomButtonContained
						text={'Reset Password'}
						onClick={onSubmitClicked}
					/>

					<p
						onClick={() => navigate('/login')}
						style={{fontSize: 14, color: 'blue', textDecoration: 'underline', cursor: 'pointer'}}>Log In</p>

				</div>

			</div>

		</main>
	);
}
